import { useMemo } from 'react';
import { gql, useQuery } from '@apollo/client';

const PAGE_OF_TASK_RESOURCE_ROLE_ASSIGNMENTS_QUERY = gql`
  query GetPageOfTaskResourceRoleAssignments(
    $taskId: String!
    $userUri: String!
    $page: Int!
    $pageSize: Int!
    $filter: TaskRoleAssignmentFilter
  ) {
    task(taskId: $taskId) {
      id
      taskResourceRoleAssignments(
        userUri: $userUri
        page: $page
        pageSize: $pageSize
        filter: $filter
      ) {
        roleAssignments {
          projectRole {
            id
            displayText
          }
          isDefault
        }
      }
    }
  }
`;

const usePageOfTaskResourceRoleAssignments = ({
  taskUri,
  userUri,
  page,
  pageSize,
  textSearch,
  skip = false
}) => {
  const { data, loading } = useQuery(
    PAGE_OF_TASK_RESOURCE_ROLE_ASSIGNMENTS_QUERY,
    {
      variables: {
        taskId: taskUri,
        userUri,
        page,
        pageSize,
        filter: textSearch ? { textSearch } : null
      },
      skip: skip || !taskUri || !userUri,
      fetchPolicy: 'cache-and-network'
    }
  );

  const roleAssignments =
    data?.task?.taskResourceRoleAssignments?.roleAssignments;

  const roles = useMemo(
    () =>
      (roleAssignments ?? []).map(({ projectRole }) => ({
        roleUri: projectRole.id,
        displayText: projectRole.displayText,
        isAssigned: true
      })),
    [roleAssignments]
  );

  return {
    roles,
    hasMore: roles.length === pageSize,
    loading
  };
};

export default usePageOfTaskResourceRoleAssignments;
